<template>
    <v-card>
        <v-snackbar :color="color" :timeout="callbackResponse.timeout" top v-model="snackbar">
            {{callbackResponse.message}}
            <v-btn @click="snackbar = false" dark text>Close</v-btn>
        </v-snackbar>
        <v-toolbar class="darken-4" color="indigo" dark>
            <v-toolbar-title>
                {{$t('send_budget')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn @click="dialogueClose" dark text>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="mt-5">के तपाई यो बजेट साँच्चै पठाउन चाहनु हुन्छ ? </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="dialogueClose">{{$t('no')}}</v-btn>
                <v-btn color="green darken-1" text @click="sendDatass">{{$t('yes')}}</v-btn>
            </v-card-actions>
    </v-card>

</template>

<script>
    import axios from "axios";

    export default {
        name: 'ApprovedComponent',
        computed: {
            
        },
        props: ['approvebudgetbtnData'],
        components: {},
        data() {
            return {
                callbackResponse: {
                    timeout: 6000,
                    message: ""
                },
                servicesData: {
                    data: {},
                    message: "",
                    color: ""
                }
            };
        },
       
        mounted() {
        },

        methods: {
            sendDatass() {

                let paramss = {
                    reportID: this.approvebudgetbtnData.reportID,
                    reportLogID : this.approvebudgetbtnData.reportLogID,
                    isQuarterly : this.approvebudgetbtnData.isQuarterly,
                }

                axios.post("ReportSettings/SendBudgettoOffice", paramss, {})
                    .then((response) => {
                        this.servicesData.data = response.data
                        this.servicesData.message = "Data Sent Succcessfully"
                        this.servicesData.color = "success"
                        this.dialogueClose()
                        this.$emit("formResponse", this.servicesData);
                    })
                    .catch(response => {
                        this.servicesData.data = response.data
                        this.servicesData.message = "Could not Send Please Contact Admin"
                        this.servicesData.color = "error"
                        this.dialogueClose()

                    });
            },
            dialogueClose() {
                this.dialog = true
                this.$emit("formResponse", this.dialog);
            },
            

        }
    };
</script>

